// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__fufMg","list":"PatternAutocomplete_list__8Plow"};